import {
  TGroupConfig,
  TLayoutConfig,
} from 'react-lib/components/organisms/CustomFieldGroupsSettings';

export type TPointFieldsLayoutField = { type: 'FIELD'; id: string };
export type TPointFieldsLayoutGroup = {
  type: 'GROUP';
  id: string;
  title: string;
  fieldIds: string[];
};
export type TPointFieldsLayoutEntry = TPointFieldsLayoutField | TPointFieldsLayoutGroup;
export type TPointFieldsDisplay = 'flat' | 'grouped' | 'loading';

function toGroupEntry(
  group: TGroupConfig,
  visibleFieldIds: string[],
): TPointFieldsLayoutGroup | null {
  const fieldIds = group.items.map((item) => item.id).filter((id) => visibleFieldIds.includes(id));

  if (fieldIds.length === 0) {
    return null;
  }

  return { type: 'GROUP', id: group.id ?? group.title, title: group.title, fieldIds };
}

function toFieldEntry(id: string, visibleFieldIds: string[]): TPointFieldsLayoutField | null {
  if (!visibleFieldIds.includes(id)) {
    return null;
  }

  return { type: 'FIELD', id };
}

function toEntry(layout: TLayoutConfig, visibleFieldIds: string[]): TPointFieldsLayoutEntry | null {
  switch (layout.type) {
    case 'GROUP':
      return toGroupEntry(layout, visibleFieldIds);
    case 'FIELD':
      return toFieldEntry(layout.id, visibleFieldIds);
    default: {
      const unhandled: never = layout;

      return unhandled;
    }
  }
}

export function buildPointFieldsLayoutEntries({
  fieldsLayout,
  visibleFieldIds,
}: {
  fieldsLayout: TLayoutConfig[];
  visibleFieldIds: string[];
}): TPointFieldsLayoutEntry[] {
  return fieldsLayout
    .map((layout) => toEntry(layout, visibleFieldIds))
    .filter((entry): entry is TPointFieldsLayoutEntry => entry !== null);
}
